import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";

const BookingSuccessPage = () => {
  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, 0);

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, []);
  return (
    <div className="info-page">
      <div className="info-page-header">
        <Link to="/" className="back-button">
          ✕
        </Link>

        <h1>Бронь успешна 🎉</h1>
      </div>

      <div className="info-card success-card">
        <div className="success-hero">
          <div className="success-icon">✓</div>

          <h2>Ваш столик успешно забронирован 🩷</h2>

          <p className="success-subtitle">
            Спасибо за бронирование в бильярдном клубе The Feel's
          </p>
        </div>

        <div className="success-section">
          <h3 className="success-section-title">
            Перед посещением рекомендуем прочитать ✨
          </h3>

          <div className="success-links">
            <Link to="/rules" className="success-nav-button">
              Правила клуба 📝
            </Link>

            <Link to="/how-to-find" className="success-nav-button">
              Как пройти 🗺️
            </Link>

            <Link to="/contacts" className="success-nav-button">
              Контакты ☎️
            </Link>
          </div>
        </div>

        <div className="success-section">
          <h3 className="success-section-title">Подписывайтесь 🫶</h3>

          <div className="contacts-buttons">
            <a
              href="https://t.me/thefeels_billiard"
              target="_blank"
              rel="noreferrer"
              className="contact-action-button"
            >
              Telegram канал
            </a>

            <a
              href="https://www.instagram.com/thefeels_billiard"
              target="_blank"
              rel="noreferrer"
              className="contact-action-button"
            >
              Instagram 📸
            </a>
          </div>
        </div>
      </div>

      <Link to="/" className="return-home-button">
        Забронировать ещё один столик
      </Link>
    </div>
  );
};

export default BookingSuccessPage;

